var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundInventories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 227,
    viewBox: "0 0 381 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2709_23470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 227
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2709_23470)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2709_23470)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -20,
    width: 419,
    height: 257,
    rx: 20,
    fill: "white",
    fillOpacity: 0.03
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.063 0H130.043L-0.0156555 226.999C0.0643679 227 0.144504 227 0.224751 227H361C372.046 227 381 218.046 381 207V97.6188L265.063 0Z",
    fill: "url(#paint0_linear_2709_23470)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6321 0H6C-5.04569 0 -14 8.95431 -14 20V207C-14 218.046 -5.04569 227 6 227H266.983L41.6321 0Z",
    fill: "url(#paint1_linear_2709_23470)",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: 129.143,
    width: 45.8571,
    height: 45.8571,
    rx: 2,
    fill: "#E0E8FB"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 47.1429,
    y: 129.143,
    width: 45.8571,
    height: 45.8571,
    rx: 2,
    fill: "#ADC4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: -14,
    y: 68,
    width: 45.8571,
    height: 45.8571,
    rx: 2,
    fill: "#ADC4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2709_23470",
    x: -104,
    y: -100,
    width: 579,
    height: 417,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2709_23470"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2709_23470",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2709_23470",
    x1: 23,
    y1: 221,
    x2: 284.5,
    y2: 59.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.713695,
    stopColor: "#DEE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2709_23470",
    x1: 261.5,
    y1: 218.5,
    x2: -9.99999,
    y2: 0.00000227155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BBCE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundInventories);
export default __webpack_public_path__ + "static/media/backgroundInventories.8bd2937969faa95aebd7f9b8a73eb998.svg";
export { ForwardRef as ReactComponent };